/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function CandidateAndPartySpendingAndReimbursementsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Candidate and Party Spending and Reimbursements"
              description={
                <>
                <h4>The chart below provides the Candidate and Party spending limits and reimbursements for the 42nd provincial general election. Third party maximum spending is listed as well.</h4>
                <br /><h3>Candidate and Party Spending Limits and Reimbursements for the 42nd Provincial General Election</h3>
                  <br /><p>Final elector counts as of Feb 10, 2025 for the List of Electors and the Nova Scotia Elections Act of 2011.</p>
                  <br /><p>Index updated for 2011 (2.8%) 2012 (1.8%) 2013 (1.4%) 2014 (0.06%) 2015 (1.2%) 2016 (1.3%) 2017 (1.7%) 2018 (1.6%) 2019 (2.2%) 2020 (0.6%), 2021 (4.8%), 2022 (7.6%), 2023 (3.6%)</p>
                  <br />
                  <p><table border="1" cellPadding="1" cellSpacing="1"><thead>
                    <tr>
                      <td>Amounts in Elections Act</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>$1.43</td>
                      <td>$2.29</td>
                    </tr><tr>
                      <td> Updated for CPI 2011 to 2023</td>
                      <td>24-Oct-24</td>
                      <td>10-Feb-25</td>
                      <td></td>
                      <td></td>
                      <td>$1.94</td>
                      <td>$3.11</td>
                    </tr>
                    <tr>
                      <th><strong>Electoral District</strong></th>
                      <th><strong>Initial Number of Electors Oct 24, 2024</strong></th>
                      <th><strong>Final Number of Electors Feb 10, 2025</strong></th>
                      <th><strong>*Elector Count for Spending & Reimbursement  Limits</strong></th>
                      <th><strong>Total Candidate Spending Limit</strong></th>
                      <th><strong>Candidate Reimbursement</strong></th>
                      <th><strong>Total Registered Party Spending Limit</strong></th>
                    </tr>
                  </thead>
                    <tbody>
                      <tr>
                        <td className="style1" style={{ height: '25px' }}>Annapolis</td>
                        <td className="style1">15,863</td>
                        <td className="style1">16,038</td>
                        <td className="style1">16,038</td>
                        <td className="style1">$107,030</td>
                        <td className="style1">$31,149</td>
                        <td className="style1">$49,883</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>Antigonish</td>
                        <td className="style1">15,196</td>
                        <td className="style1">15,422</td>
                        <td className="style1">15,422</td>
                        <td className="style1">$103,441</td>
                        <td className="style1">$29,953</td>
                        <td className="style1">$47,967</td>
                      </tr>
                      <tr>
                        <td className="style1">Argyle</td>
                        <td className="style1">6,784</td>
                        <td className="style1">6,873</td>
                        <td className="style1">6,873</td>
                        <td className="style1">$50,620</td>
                        <td className="style1">$13,349</td>
                        <td className="style1">$21,377</td>
                      </tr>
                      <tr>
                        <td className="style1">Bedford Basin</td>
                        <td className="style1">13,154</td>
                        <td className="style1">13,194</td>
                        <td className="style1">13,194</td>
                        <td className="style1">$90,459</td>
                        <td className="style1">$25,626</td>
                        <td className="style1">$41,037</td>
                      </tr>
                      <tr>
                        <td className="style1">Bedford South</td>
                        <td className="style1">16,293</td>
                        <td className="style1">16,545</td>
                        <td className="style1">16,545</td>
                        <td className="style1">$109,984</td>
                        <td className="style1">$32,134</td>
                        <td className="style1">$51,460</td>
                      </tr>
                      <tr>
                        <td className="style1">Cape Breton Centre-Whitney Pier </td>
                        <td className="style1">14,672</td>
                        <td className="style1">14,781</td>
                        <td className="style1">14,781</td>
                        <td className="style1">$99,706</td>
                        <td className="style1">$28,708</td>
                        <td className="style1">$45,973</td>
                      </tr>
                      <tr>
                        <td className="style1">Cape Breton East </td>
                        <td className="style1">14,258</td>
                        <td className="style1">14,391</td>
                        <td className="style1">14,391</td>
                        <td className="style1">$97,434</td>
                        <td className="style1">$27,951</td>
                        <td className="style1">$44,760</td>
                      </tr>
                      <tr>
                        <td className="style1">Chester-St. Margaret&#39;s </td>
                        <td className="style1">16,319</td>
                        <td className="style1">16,521</td>
                        <td className="style1">16,521</td>
                        <td className="style1">$109,845</td>
                        <td className="style1">$32,088</td>
                        <td className="style1">$51,385</td>
                      </tr>
                      <tr>
                        <td className="style1">Clare </td>
                        <td className="style1">7,089</td>
                        <td className="style1">7,267</td>
                        <td className="style1">7,267</td>
                        <td className="style1">$52,634</td>
                        <td className="style1">$14,114</td>
                        <td className="style1">$22,602</td>
                      </tr>
                      <tr>
                        <td className="style1">Clayton Park West </td>
                        <td className="style1">14,323</td>
                        <td className="style1">14,614</td>
                        <td className="style1">14,614</td>
                        <td className="style1">$98,733</td>
                        <td className="style1">$28,384</td>
                        <td className="style1">$45,454</td>
                      </tr>
                      <tr>
                        <td className="style1">Colchester-Musquodoboit Valley </td>
                        <td className="style1">15,434</td>
                        <td className="style1">15,505</td>
                        <td className="style1">15,505</td>
                        <td className="style1">$103,925</td>
                        <td className="style1">$30,114</td>
                        <td className="style1">$48,225</td>
                      </tr>
                      <tr>
                        <td className="style1">Colchester North </td>
                        <td className="style1">15,827</td>
                        <td className="style1">15,907</td>
                        <td className="style1">15,907</td>
                        <td className="style1">$106,267</td>
                        <td className="style1">$30,895</td>
                        <td className="style1">$49,475</td>
                      </tr>
                      <tr>
                        <td className="style1">Cole Harbour</td>
                        <td className="style1">10,007</td>
                        <td className="style1">10,135</td>
                        <td className="style1">10,135</td>
                        <td className="style1">$72,682</td>
                        <td className="style1">$19,684</td>
                        <td className="style1">$31,523</td>
                      </tr>
                      <tr>
                        <td className="style1">Cole Harbour-Dartmouth </td>
                        <td className="style1">16,587</td>
                        <td className="style1">16,802</td>
                        <td className="style1">16,802</td>
                        <td className="style1">$111,482</td>
                        <td className="style1">$32,633</td>
                        <td className="style1">$52,259</td>
                      </tr>
                      <tr>
                        <td className="style1">Cumberland North</td>
                        <td className="style1">14,177</td>
                        <td className="style1">14,277</td>
                        <td className="style1">14,277</td>
                        <td className="style1">$96,769</td>
                        <td className="style1">$27,729</td>
                        <td className="style1">$44,405</td>
                      </tr>
                      <tr>
                        <td className="style1">Cumberland South </td>
                        <td className="style1">11,729</td>
                        <td className="style1">11,810</td>
                        <td className="style1">11,810</td>
                        <td className="style1">$82,395</td>
                        <td className="style1">$22,938</td>
                        <td className="style1">$36,732</td>
                      </tr>
                      <tr>
                        <td className="style1">Dartmouth East</td>
                        <td className="style1">14,493</td>
                        <td className="style1">14,577</td>
                        <td className="style1">14,577</td>
                        <td className="style1">$98,517</td>
                        <td className="style1">$28,312</td>
                        <td className="style1">$45,339</td>
                      </tr>
                      <tr>
                        <td className="style1">Dartmouth North</td>
                        <td className="style1">16,175</td>
                        <td className="style1">16,261</td>
                        <td className="style1">16,261</td>
                        <td className="style1">$108,330</td>
                        <td className="style1">$31,583</td>
                        <td className="style1">$50,576</td>
                      </tr>
                      <tr>
                        <td className="style1">Dartmouth South</td>
                        <td className="style1">13,547</td>
                        <td className="style1">13,680</td>
                        <td className="style1">13,680</td>
                        <td className="style1">$93,291</td>
                        <td className="style1">$26,570</td>
                        <td className="style1">$42,549</td>
                      </tr>
                      <tr>
                        <td className="style1">Digby-Annapolis </td>
                        <td className="style1">10,871</td>
                        <td className="style1">10,928</td>
                        <td className="style1">10,928</td>
                        <td className="style1">$77,256</td>
                        <td className="style1">$21,225</td>
                        <td className="style1">$33,989</td>
                      </tr>
                      <tr>
                        <td className="style1">Eastern Passage </td>
                        <td className="style1">10,624</td>
                        <td className="style1">10,798</td>
                        <td className="style1">10,798</td>
                        <td className="style1">$76,498</td>
                        <td className="style1">$20,972</td>
                        <td className="style1">$33,585</td>
                      </tr>
                      <tr>
                        <td className="style1">Eastern Shore </td>
                        <td className="style1">17,580</td>
                        <td className="style1">17,700</td>
                        <td className="style1">17,700</td>
                        <td className="style1">$116,714</td>
                        <td className="style1">$34,377</td>
                        <td className="style1">$55,052</td>
                      </tr>
                      <tr>
                        <td className="style1">Fairview-Clayton Park </td>
                        <td className="style1">15,673</td>
                        <td className="style1">15,850</td>
                        <td className="style1">15,850</td>
                        <td className="style1">$105,935</td>
                        <td className="style1">$30,784</td>
                        <td className="style1">$49,298</td>
                      </tr>
                      <tr>
                        <td className="style1">Glace Bay-Dominion </td>
                        <td className="style1">13,246</td>
                        <td className="style1">13,353</td>
                        <td className="style1">13,353</td>
                        <td className="style1">$91,386</td>
                        <td className="style1">$25,935</td>
                        <td className="style1">$41,532</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>Guysborourgh-Tracadie</td>
                        <td className="style1">7,955</td>
                        <td className="style1">8,018</td>
                        <td className="style1">8,018</td>
                        <td className="style1">$58,350</td>
                        <td className="style1">$15,573</td>
                        <td className="style1">$24,938</td>
                      </tr>
                      <tr>
                        <td className="style1">Halifax Armdale </td>
                        <td className="style1">14,107</td>
                        <td className="style1">14,426</td>
                        <td className="style1">14,426</td>
                        <td className="style1">$97,638</td>
                        <td className="style1">$28,019</td>
                        <td className="style1">$44,869</td>
                      </tr>
                      <tr>
                        <td className="style1">Halifax Atlantic </td>
                        <td className="style1">16,344</td>
                        <td className="style1">16,464</td>
                        <td className="style1">16,464</td>
                        <td className="style1">$109,512</td>
                        <td className="style1">$31,977</td>
                        <td className="style1">$51,208</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>Halifax Chebucto </td>
                        <td className="style1">12,460</td>
                        <td className="style1">12,763</td>
                        <td className="style1">12,763</td>
                        <td className="style1">$87,948</td>
                        <td className="style1">$24,789</td>
                        <td className="style1">$39,696</td>
                      </tr>
                      <tr>
                        <td className="style1">Halifax Citadel-Sable Island </td>
                        <td className="style1">17,009</td>
                        <td className="style1">17,805</td>
                        <td className="style1">17,805</td>
                        <td className="style1">$117,326</td>
                        <td className="style1">$34,581</td>
                        <td className="style1">$55,378</td>
                      </tr>
                      <tr>
                        <td className="style1">Halifax Needham </td>
                        <td className="style1">17,040</td>
                        <td className="style1">17,446</td>
                        <td className="style1">17,446</td>
                        <td className="style1">$115,234</td>
                        <td className="style1">$33,884</td>
                        <td className="style1">$54,262</td>
                      </tr>
                      <tr>

                        <td className="style1">Hammonds Plains-Lucasville </td>
                        <td className="style1">15,648</td>
                        <td className="style1">15,831</td>
                        <td className="style1">15,831</td>
                        <td className="style1"> $105,824</td>
                        <td className="style1"> $30,747</td>
                        <td className="style1"> $49,239</td>
                      </tr>

                      <tr>
                        <td className="style1">Hants East </td>
                        <td className="style1">18,969</td>
                        <td className="style1">19,148</td>
                        <td className="style1">19,148</td>
                        <td className="style1">$125,151</td>
                        <td className="style1">$37,190</td>
                        <td className="style1">$59,556</td>
                      </tr>
                      <tr>
                        <td className="style1">Hants West </td>
                        <td className="style1">17,528</td>
                        <td className="style1">17,707</td>
                        <td className="style1">17,707</td>
                        <td className="style1">$116,755</td>
                        <td className="style1">$34,391</td>
                        <td className="style1">$55,074</td>
                      </tr>
                      <tr>
                        <td className="style1">Inverness </td>
                        <td className="style1">14,473</td>
                        <td className="style1">14,534</td>
                        <td className="style1">14,534</td>
                        <td className="style1">$98,267</td>
                        <td className="style1">$28,228</td>
                        <td className="style1">$45,205</td>
                      </tr>
                      <tr>
                        <td className="style1">Kings North </td>
                        <td className="style1">17,025</td>
                        <td className="style1">17,151</td>
                        <td className="style1">17,151</td>
                        <td className="style1">$113,515</td>
                        <td className="style1">$33,311</td>
                        <td className="style1">$53,344</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>Kings South </td>
                        <td className="style1">17,386</td>
                        <td className="style1">17,617</td>
                        <td className="style1">17,617</td>
                        <td className="style1">$116,231</td>
                        <td className="style1">$34,216</td>
                        <td className="style1">$54,794</td>
                      </tr>
                      <tr>
                        <td className="style1">Kings West </td>
                        <td className="style1">17,945</td>
                        <td className="style1">18,164</td>
                        <td className="style1">18,164</td>
                        <td className="style1">$119,418</td>
                        <td className="style1">$35,279</td>
                        <td className="style1">$56,495</td>
                      </tr>
                      <tr>
                        <td className="style1">Lunenburg </td>
                        <td className="style1">15,281</td>
                        <td className="style1">15,454</td>
                        <td className="style1">15,454</td>
                        <td className="style1">$103,627</td>
                        <td className="style1">$30,015</td>
                        <td className="style1">$48,066</td>
                      </tr>
                      <tr>
                        <td className="style1">Lunenburg West </td>
                        <td className="style1">17,198</td>
                        <td className="style1">17,217</td>
                        <td className="style1">17,217</td>
                        <td className="style1">$113,900</td>
                        <td className="style1">$33,439</td>
                        <td className="style1">$53,550</td>
                      </tr>
                      <tr>
                        <td className="style1">Northside Westmount </td>
                        <td className="style1">16,259</td>
                        <td className="style1">16,381</td>
                        <td className="style1">16,381</td>
                        <td className="style1">$109,029</td>
                        <td className="style1">$31,816</td>
                        <td className="style1">$50,949</td>
                      </tr>
                      <tr>
                        <td className="style1">Pictou Centre </td>
                        <td className="style1">13,421</td>
                        <td className="style1">13,553</td>
                        <td className="style1">13,553</td>
                        <td className="style1">$92,551</td>
                        <td className="style1">$26,323</td>
                        <td className="style1">$42,154</td>
                      </tr>

                      <tr>
                        <td className="style1">Pictou East </td>
                        <td className="style1">12,027</td>
                        <td className="style1">12,170</td>
                        <td className="style1">12,170</td>
                        <td className="style1">$84,493</td>
                        <td className="style1">$23,637</td>
                        <td className="style1">$37,852</td>
                      </tr>
                      <tr>
                        <td className="style1">Pictou West </td>
                        <td className="style1">12,270</td>
                        <td className="style1">12,293</td>
                        <td className="style1">12,293</td>
                        <td className="style1">$85,209</td>
                        <td className="style1">$23,876</td>
                        <td className="style1">$38,235</td>
                      </tr>
                      <tr>
                        <td className="style1">Preston </td>
                        <td className="style1">11,041</td>
                        <td className="style1">11,100</td>
                        <td className="style1">11,100</td>
                        <td className="style1">$78,258</td>
                        <td className="style1">$21,559</td>
                        <td className="style1">$34,524</td>
                      </tr>
                      <tr>
                        <td className="style1">Queens </td>
                        <td className="style1">9,232</td>
                        <td className="style1">9,333</td>
                        <td className="style1">9,333</td>
                        <td className="style1">$66,779</td>
                        <td className="style1">$18,127</td>
                        <td className="style1">$29,028</td>
                      </tr>
                      <tr>
                        <td className="style1">Richmond </td>
                        <td className="style1">7,987</td>
                        <td className="style1">8,138</td>
                        <td className="style1">8,138</td>
                        <td className="style1">$58,561</td>
                        <td className="style1">$15,806</td>
                        <td className="style1">$25,311</td>
                      </tr>
                      <tr>
                        <td className="style1">Sackville-Cobequid </td>
                        <td className="style1">15,027</td>
                        <td className="style1">15,130</td>
                        <td className="style1">15,130</td>
                        <td className="style1">$101,740</td>
                        <td className="style1">$29,386</td>
                        <td className="style1">$47,058</td>
                      </tr>
                      <tr>
                        <td className="style1">Sackville-Uniacke </td>
                        <td className="style1">14,008</td>
                        <td className="style1">14,108</td>
                        <td className="style1">14,108</td>
                        <td className="style1">$95,785</td>
                        <td className="style1">$27,401</td>
                        <td className="style1">$43,880</td>
                      </tr>
                      <tr>
                        <td className="style1">Shelburne </td>
                        <td className="style1">11,779</td>
                        <td className="style1">11,853</td>
                        <td className="style1">11,853</td>
                        <td className="style1">$82,646</td>
                        <td className="style1">$23,021</td>
                        <td className="style1">$36,866</td>
                      </tr>
                      <tr>
                        <td className="style1">Sydney-Membertou </td>
                        <td className="style1">15,488</td>
                        <td className="style1">15,558</td>
                        <td className="style1">15,558</td>
                        <td className="style1">$104,233</td>
                        <td className="style1">$30,217</td>
                        <td className="style1">$48,390</td>
                      </tr>
                      <tr>
                        <td className="style1">Timberlea-Prospect </td>
                        <td className="style1">18,164</td>
                        <td className="style1">18,344</td>
                        <td className="style1">18,344</td>
                        <td className="style1">$120,467</td>
                        <td className="style1">$35,628</td>
                        <td className="style1">$57,055</td>
                      </tr>
                      <tr>
                        <td className="style1">Truro-Bible Hill-Millbrook-Salmon River </td>
                        <td className="style1">16,847</td>
                        <td className="style1">16,996</td>
                        <td className="style1">16,996</td>
                        <td className="style1">$112,612</td>
                        <td className="style1">$33,010</td>
                        <td className="style1">$52,862</td>
                      </tr>
                      <tr>
                        <td className="style1">Victoria-The Lakes </td>
                        <td className="style1">13,062</td>
                        <td className="style1">13,182</td>
                        <td className="style1">13,182</td>
                        <td className="style1">$90,389</td>
                        <td className="style1">$25,602</td>
                        <td className="style1">$41,000</td>
                      </tr>
                      <tr>
                        <td className="style1">Waverley-Fall River-Beaver Bank </td>
                        <td className="style1">18,092</td>
                        <td className="style1">18,237</td>
                        <td className="style1">18,237</td>
                        <td className="style1">$119,843</td>
                        <td className="style1">$35,420</td>
                        <td className="style1">$56,722</td>
                      </tr>

                      <tr>
                        <td className="style1">Yarmouth </td>
                        <td className="style1">14,404</td>
                        <td className="style1">14,563</td>
                        <td className="style1">14,563</td>
                        <td className="style1">$98,436</td>
                        <td className="style1">$28,285</td>
                        <td className="style1">$45,295</td>
                      </tr>

                      <tr>
                        <td><strong>Totals</strong></td>
                        <td><strong>785,397</strong></td>
                        <td ><strong>793,913</strong></td>
                        <td ><strong>793,913</strong></td>
                        <td><strong>5,361,060</strong></td>
                        <td><strong>1,541,958</strong></td>
                        <td><strong>2,469,290</strong></td>
                      </tr>
                    </tbody>
                  </table>
                  </p>
                  <br />
                  <br />
                  <p><h4>Third Party maximum spending general election (s.275): $13,582</h4></p><br />
                  <p>The final calculation is based on the final list of electors dated February 10, 2025.</p>
                  <p>The chart of <a href="/files/CandidateSpendingAndReimbursements/Final Spending Limit Feb 10 2025.pdf"><u>candidate and registered party spending limits and reimbursements</u></a> for the 42nd provincial general election is also available in PDF format.</p>
                  <br />
                  <h3>Financial Reporting Deadlines for the 42nd Provincial General Election</h3>
                  <br />
                  <p>Elections Nova Scotia reminds all nominated candidates, registered political parties, and third party advertisers from the 42nd provincial general election held on Tuesday, November 26, 2024, that financial reports are due in the weeks and months ahead. All reports must be sent to the Chief Electoral Officer.</p>
                  <br /><p>Candidate tax receipts are due 30 days after election day, December 30, 2024.</p>
                  <br /><p>Candidate financial reports, including audit reports, are due (80 days after writ) on February 28, 2025. It is also important to remember that there are fines of $50 per day for late candidate reports.</p>
                  <br /><p>Registered party financial reports are due (120 days after Writ) on April 9, 2025.</p>
                  <br /><p>Third party election advertising reports are due on March 26, 2025.
                  </p>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CandidateAndPartySpendingAndReimbursementsInformation;
